import { FC } from "react";
import { Button } from "react-bootstrap";

interface TabBarProps {
  tabs: GeneralItem[];
  selectedTabId: number;
  onTabChange: (tabId: number) => void;
}

const TabBar: FC<TabBarProps> = ({ tabs, selectedTabId, onTabChange }) => {
  return (
    <ul className="d-flex flex-wrap list-unstyled justify-content-end justify-content-center justify-content-md-end tab-responsive">
      {tabs.map((tab) => (
        <li className="mx-2 my-1 " key={tab.id}>
          <Button
            className={
              tab.id === selectedTabId
                ? "default-btn border-bottom-dark rounded-0 d-flex"
                : "default-btn rounded-0 d-flex"
            }
            onClick={() => onTabChange(tab.id)}
          >
            {tab.icon && <span className="me-1 me-md-2">{tab.icon}</span>}
            <p className="p-0 m-0">{tab.label}</p>
          </Button>
        </li>
      ))}
    </ul>
  );
};
export default TabBar;
